import { useCallback, useMemo, useRef, useState } from 'react';
import { useI18nState } from '../../../stores/settings/language-context';
import {
  approvalWorkflows,
  contacts,
  delegates,
  influencers,
  initialDelegations,
  profileData,
  WorkflowDelegation
} from './view-profile.interface';

export function useViewProfile() {
  const { localeData } = useI18nState();
  const [pickUpFromDate, setPickUpFromDate] = useState<
    string | number | Date
  >();
  const [pickUpToDate, setPickUpToDate] = useState<string | number | Date>();
  const [isOutOfOffice, setIsOutOfOffice] = useState(false);
  const [formData, setFormData] = useState<Partial<WorkflowDelegation>>({
    userName: localeData.DefaultUserName,
    approvalWorkflow: '',
    fromDate: '',
    toDate: '',
    delegatee: ''
  });

  const columnDefs = useMemo(
    () => [
      {
        headerName: localeData.UserName,
        field: 'userName',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: localeData.ApprovalWorkflow,
        field: 'approvalWorkflow',
        sortable: true,
        filter: true,
        width: 180
      },
      {
        headerName: localeData.FromDate,
        field: 'fromDate',
        sortable: true,
        filter: true,
        width: 120
      },
      {
        headerName: localeData.ToDate,
        field: 'toDate',
        sortable: true,
        filter: true,
        width: 120
      },
      {
        headerName: localeData.Delegatee,
        field: 'delegatee',
        sortable: true,
        filter: true,
        width: 150
      }
    ],
    [localeData]
  );

  const gridRef = useRef(null);

  const handlePickUpFromDateChange = useCallback((e: any) => {
    setPickUpFromDate(e);
  }, []);

  const handlePickUpToDateChange = useCallback((e: any) => {
    setPickUpToDate(e);
  }, []);

  const handleClear = () => {
    setFormData({
      userName: localeData.DefaultUserName,
      approvalWorkflow: '',
      fromDate: '',
      toDate: '',
      delegatee: ''
    });
  };

  return {
    localeData,
    profileData,
    contacts,
    influencers,
    approvalWorkflows,
    delegates,
    initialDelegations,
    columnDefs,
    gridRef,
    pickUpFromDate,
    pickUpToDate,
    isOutOfOffice,
    formData,
    handlePickUpFromDateChange,
    handlePickUpToDateChange,
    handleClear,
    setIsOutOfOffice,
    setFormData
  };
}
